// import { producaov2 as api } from "./apis";
export const TOKEN_KEY = "Token";
export const TOKEN_JWT = "NewToken";

export const USER_KEY = "USER";
export const NOTIFY_KEY = "NOTIFY";
export const _IS_ADM_KEY = "_IS_ADM";
export const _IS_EMP_KEY = "_IS_EMP";

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const isAuthAdmin = async () => {
    return true;
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const login = (token = "") => {
  if (token === "") return;
  let tokenIOS = token.replace("%7C/cursos", "");
  tokenIOS = tokenIOS.replace("|/cursos", "");
  tokenIOS = tokenIOS.replace("http://localhost:3000/OAuth?", "");
  tokenIOS = tokenIOS.replace("https://www.voitto.com.br/OAuth?", "");
  tokenIOS = tokenIOS.replace("https://voitto.com.br/OAuth?", "");

  localStorage.setItem(TOKEN_KEY, tokenIOS);
  return true;
};

export const setNewToken = (token = "") => {
  if (token === "") return;
  localStorage.setItem(TOKEN_JWT, token);
  return true;
};

export const logout = () => {
  localStorage.setItem(USER_KEY, null);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(NOTIFY_KEY);

  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }

  return true;
};

// DADOS DO USUARIO

export const setUSER = (json = {}) => {
  if (json === {}) return;
  localStorage.setItem(USER_KEY, JSON.stringify(json));
  if (localStorage.NOTIFY == undefined) {
    localStorage.setItem(NOTIFY_KEY, "1");
  }
};

export const getUSER = () =>
  JSON.parse(localStorage.getItem(USER_KEY) != null)
    ? JSON.parse(localStorage.getItem(USER_KEY))
    : {
        email: "0",
        foto: "0",
        id: "0",
        is_premium: "0",
        nome: "0",
        aluno_empresa: "0",
      };

// IS_ADMIN

export const IS_ADMIN_SET = (bool = false) => {
  localStorage.setItem(_IS_ADM_KEY, bool);
};
export const IS_ADMIN = () => JSON.parse(localStorage.getItem(_IS_ADM_KEY));

//IS_EMPRESA

export const IS_EMPRESA_SET = (bool = false) => {
  localStorage.setItem(_IS_EMP_KEY, bool);
};

export const IS_EMPRESA = () => JSON.parse(localStorage.getItem(_IS_EMP_KEY));
